import { Field } from "redux-form";
import React from "react";
import { TextInput } from "../../../../common/form";
import PropTypes from "prop-types";

const DEFAULT_COMPONENT = TextInput;

const BrokerField = ({ name, required, translateFn, extraProps }) => (
  <div>
    <Field
      id={name}
      name={name}
      key={name}
      required={required}
      label={translateFn(name)}
      component={DEFAULT_COMPONENT}
      {...extraProps}
    />
  </div>
);

BrokerField.propTypes = {
  name: PropTypes.string.isRequired,
  translateFn: PropTypes.func.isRequired,
  extraProps: PropTypes.object,
  required: PropTypes.bool,
};

export default BrokerField;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/formSections/BrokerField.js